const updates = [
  {
    date: '2026.07.28',
    tag: '更新',
    tagColor: 'bg-primary-100 text-primary-700',
    title: '《秘密恋爱》第128话更新 — 男主告白名场面来袭',
  },
  {
    date: '2026.07.27',
    tag: '新作',
    tagColor: 'bg-accent-100 text-accent-700',
    title: '校园恋爱新作《那年夏天的约定》正式上线，首周免费全集',
  },
  {
    date: '2026.07.26',
    tag: '排行',
    tagColor: 'bg-secondary-100 text-secondary-700',
    title: '本周韩漫热度排行刷新，《剑与魔法》重回前三',
  },
  {
    date: '2026.07.25',
    tag: '完结',
    tagColor: 'bg-primary-100 text-primary-700',
    title: '人气韩漫《恶魔契约》正篇完结，番外篇连载决定',
  },
  {
    date: '2026.07.24',
    tag: '活动',
    tagColor: 'bg-accent-100 text-accent-700',
    title: '「夏日韩漫祭」读者票选活动启动，选出你最爱的作品',
  },
  {
    date: '2026.07.23',
    tag: '更新',
    tagColor: 'bg-primary-100 text-primary-700',
    title: '《暗夜追凶》第56话更新 — 真凶身份揭晓引热议',
  },
  {
    date: '2026.07.22',
    tag: '新作',
    tagColor: 'bg-accent-100 text-accent-700',
    title: '奇幻题材《异世界药局》上线，医疗系韩漫新风向',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="w-full max-w-[960px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">最新动态</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            布丁漫画每日更新动态、新作上架与活动资讯，不错过任何精彩
          </p>
        </div>

        <div className="relative pl-8 md:pl-10 border-l-2 border-background-200 space-y-6">
          {updates.map((item, i) => (
            <div key={i} className="relative">
              <div className="absolute -left-[calc(2rem+3px)] md:-left-[calc(2.5rem+3px)] top-1 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-50"></div>
              <div className="flex flex-wrap items-center gap-2 mb-1">
                <span className="text-xs text-foreground-400 font-medium">{item.date}</span>
                <span className={`px-2 py-0.5 text-xs font-medium rounded-full whitespace-nowrap ${item.tagColor}`}>
                  {item.tag}
                </span>
              </div>
              <p className="text-sm md:text-base text-foreground-800 leading-relaxed">{item.title}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}